import { makeStyles } from "tss-react/mui";

export const useStyle = makeStyles()(() => ({
    subtitleLoginLink: {
        cursor: "pointer",
        textDecoration: "underline",
    },
}));
